import React from "react";
import { LegalShell } from "@/pages/site/LegalShell";

export default function Datenschutz() {
  return (
    <LegalShell title="Datenschutzerklärung">
      <p>
        Der Schutz deiner persönlichen Daten ist uns wichtig. Wir verarbeiten personenbezogene Daten
        ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, BDSG). In dieser Erklärung
        informieren wir dich über die wichtigsten Aspekte der Datenverarbeitung auf dieser Website.
      </p>

      <h2>1. Verantwortlicher</h2>
      <p>
        Ivan Giombini<br />
        Ringstraße 22b, 97816 Lohr am Main<br />
        E-Mail: <a href="mailto:kontakt@teamtempus.de">kontakt@teamtempus.de</a>
      </p>

      <h2>2. Aufruf der Website / Server-Logfiles</h2>
      <p>
        Beim Aufrufen dieser Website werden durch den Hosting-Provider automatisch Informationen in
        sogenannten Server-Logfiles gespeichert (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene
        Seite, verwendeter Browser). Diese Daten dienen ausschließlich der technischen Bereitstellung und
        Sicherheit der Website. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem
        sicheren, störungsfreien Betrieb).
      </p>

      <h2>3. Kontaktformular &amp; Kontaktaufnahme</h2>
      <p>
        Wenn du uns über das Kontaktformular oder per E-Mail kontaktierst, verarbeiten wir die von dir
        angegebenen Daten (Name, E-Mail-Adresse, ggf. Telefonnummer sowie deine Nachricht), um deine Anfrage zu
        bearbeiten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) bzw. lit. f
        (berechtigtes Interesse an der Beantwortung). Die Daten werden gelöscht, sobald sie für die Bearbeitung
        nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungsfristen entgegenstehen.
      </p>

      <h2>4. Keine Cookies zu Tracking-Zwecken</h2>
      <p>
        Diese Website verwendet keine Analyse-, Tracking- oder Werbe-Cookies. Es werden keine Nutzungsprofile
        erstellt und keine Daten an Dritte zu Werbezwecken weitergegeben.
      </p>

      <h2>5. Hosting</h2>
      <p>
        Diese Website wird bei einem Dienstleister gehostet. Der Hoster verarbeitet in unserem Auftrag die oben
        genannten Server-Logfiles. Mit dem Anbieter besteht – soweit erforderlich – ein Vertrag zur
        Auftragsverarbeitung gemäß Art. 28 DSGVO.
      </p>

      <h2>6. Deine Rechte</h2>
      <p>
        Dir stehen gegenüber uns folgende Rechte hinsichtlich der dich betreffenden personenbezogenen Daten zu:
        Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung
        (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch gegen die Verarbeitung (Art. 21 DSGVO).
        Zudem hast du das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.
      </p>

      <h2>7. Kontakt in Datenschutzfragen</h2>
      <p>
        Bei Fragen zur Verarbeitung deiner personenbezogenen Daten wende dich bitte an:
        <a href="mailto:kontakt@teamtempus.de"> kontakt@teamtempus.de</a>.
      </p>

      <p className="text-sm text-[#94A3B8]">
        Hinweis: Diese Datenschutzerklärung ist eine allgemeine Vorlage. Bitte lass sie vor dem Live-Gang durch
        eine fachkundige Person (z. B. Rechtsanwalt/Datenschutzbeauftragten) prüfen und ergänze die
        Platzhalter mit deinen tatsächlichen Angaben.
      </p>
    </LegalShell>
  );
}
